module.exports = __webpack_public_path__ + "static/media/use4.35979155.jpeg";